<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    append-to-body
    :show-close="false"
    :close-on-click-modal="false"
    top="10vh"
    width="880px"
    custom-class="insure-info-dialog"
    center
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="formDom"
      label-width="132px"
      label-position="left"
    >
      <el-row>
        <el-col :span="12"
          ><el-form-item label="单位名称" prop="appliName">
            <el-input
              class="input form-item"
              :disabled="true"
              v-model="form.appliName"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="单位类型" prop="appliType">
            <el-select
              class="form-item"
              v-model="form.appliType"
              placeholder="请选择"
              @change="handleSelectAppliType"
            >
              <el-option value="1" label="个人"></el-option>
              <el-option value="2" label="单位"></el-option>
            </el-select> </el-form-item
        ></el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="法人姓名" prop="legalPerson">
            <el-input
              class="form-item"
              v-model="form.legalPerson"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="证件类型" prop="identifyType">
            <el-select
              class="form-item"
              v-model="form.identifyType"
              placeholder="请选择"
            >
              <el-option
                v-show="Number(form.appliType) === 1"
                value="01"
                label="身份证"
              ></el-option>
              <el-option
                v-show="Number(form.appliType) === 1"
                value="03"
                label="护照"
              ></el-option>
              <el-option
                v-show="Number(form.appliType) === 2"
                value="70"
                label="营业执照信用代码"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="证件号码" prop="identifyNumber">
            <el-input
              class="form-item"
              v-model="form.identifyNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="证件有效期" prop="validDate">
            <el-date-picker
              type="date"
              class="form-item"
              v-model="form.validDate"
              placeholder="年-月-日"
              value-format="yyyy-MM-dd"
              :disabled="longEffective"
              :picker-options="pickerOptions"
            ></el-date-picker>
            <el-checkbox
              v-model="longEffective"
              @change="changeEfficient"
              style="font-weight: 400"
              >长期有效</el-checkbox
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="联系人姓名" prop="linkerName">
            <el-input
              class="form-item"
              v-model="form.linkerName"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="联系人电话" prop="phoneNumber">
            <el-input
              class="form-item"
              v-model="form.phoneNumber"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="经营地址" prop="appliAddress">
            <el-input
              class="form-item"
              v-model="form.appliAddress"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item v-if="isPuDong" label="投保机构" prop="comCode">
            <el-select
              class="form-item"
              v-model="form.comCode"
              placeholder="请选择"
            >
              <el-option
                value="31015900"
                label="太平洋安信农业保险股份有限公司上海浦东支公司"
                key="comCode1"
              ></el-option>
              <el-option
                value="31011900"
                label="太平洋安信农业保险股份有限公司上海南汇支公司"
                key="comCode2"
              ></el-option>
              <el-option
                value="31011500"
                label="太平洋安信农业保险股份有限公司上海临港新片区支公司"
                key="comCode3"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item
            class="accountNameItem"
            label="投保人/被保险人"
            prop="accountName"
          >
            <el-input
              class="form-item"
              v-model="form.accountName"
              placeholder="请输入"
            ></el-input>
            <div style="font-weight: 400; color: #cccccc">
              请输入经营主体的全称
            </div>
          </el-form-item></el-col
        >
        <el-col :span="12">
          <el-form-item label="收款银行账号" prop="accountCode">
            <el-input
              class="form-item"
              v-model="form.accountCode"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="银行" prop="bankName">
            <el-select
              class="form-item"
              v-model="form.bankName"
              placeholder="请选择"
              v-selectLoadMore="loadMoreBank"
              @change="submitItemInfo($event, 'bankName')"
              @blur="onBlurWithBankName"
              clearable
              filterable
              remote
              :remote-method="searchBank"
            >
              <el-option
                v-for="bank in bankList"
                :key="bank.id"
                :value="bank.bankTypeName"
                :label="bank.bankTypeName"
              ></el-option>
            </el-select>
            <div style="font-weight: 400; color: #cccccc">
              请输入关键字进行搜索，不支持缩写、简称
            </div>
          </el-form-item></el-col
        >
        <el-col :span="12">
          <el-form-item label="开户支行" prop="bankBranchName">
            <el-select
              class="form-item"
              v-model="form.bankBranchName"
              placeholder="请选择"
              v-selectLoadMore="loadMoreBranchBank"
              @change="submitItemInfo($event, 'bankBranchName')"
              @blur="onBlurWithBankBranchName"
              clearable
              filterable
              remote
              :remote-method="searchBranchBank"
            >
              <el-option
                v-for="bank in branchBankList"
                :key="bank.id"
                :value="bank.bankBranchTypeName"
                :label="bank.bankBranchTypeName"
              ></el-option>
            </el-select>
            <div style="font-weight: 400; color: #cccccc">
              请输入关键字进行搜索，不支持缩写、简称
            </div>
          </el-form-item></el-col
        >
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelHandle">取 消</el-button>
      <el-button type="primary" @click="submitHandle">提交认证</el-button>
    </span>
  </el-dialog>
</template>

<script>
import validateMixins from "@/views/Insure/Form/validateMixins";
import {
  getBankList,
  getBranchBankList,
  addPersonInfo,
  editPersonInfo,
} from "@/api/request/snkd.produce";
import { getStorage } from "@/utils/storage";
import { formatDate } from "@/utils";
export default {
  mixins: [validateMixins],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isPuDong: false, // 是否是浦东新区的农场
      formInfoId: null, // 表单信息回显数据的id
      longEffective: false, // 是否长期有效
      farmId: null,
      companyId: null,
      form: {
        appliName: "",
        appliType: "",
        comCode: null,
        identifyType: "",
        identifyNumber: "",
        validDate: "",
        linkerName: "",
        phoneNumber: "",
        appliAddress: "",
        accountName: "",
        // legalPerson: "",
        accountCode: "",
        bankName: "",
        bankCode: "",
        bankBranchName: "",
        bankBranchCode: "",
        companyId: null,
        farmId: null,
      },
      pickerOptions: {
        disabledDate(time) {
          // 转换成统一时间格式再比较
          const cur = formatDate(time, "yyyy-MM-dd");
          const now = formatDate(new Date(), "yyyy-MM-dd");
          return new Date(cur).getTime() < new Date(now).getTime();
        },
      },
      // ------- 大行的数据
      bankList: [], // 银行列表
      bankTotal: 0, // 银行总数
      bankKeyword: "",
      bankPageNo: 1,
      // -------- 支行的数据
      branchBankList: [], // 支行列表
      branchBankTotal: 0, // 支行总数
      branchBankKeyword: "",
      branchBankPageNo: 1,
      title: "新增投保人信息",
    };
  },
  computed: {},
  watch: {
    editInfo(val) {
      if (val.id) {
        this.$nextTick(() => {
          this.getdetailInfo(val);
        });
      } else {
        this.longEffective = false;
      }
    },
    show() {},
  },
  async mounted() {
    this.companyInfo = getStorage("COMPANYINFO");
    this.farmInfo = getStorage("FARMINFO");
    if (this.farmInfo) {
      this.farmId = this.farmInfo.farmId;
      this.companyId = this.farmInfo.companyId;
      this.form.farmId = this.farmInfo.farmId;
      this.form.companyId = this.farmInfo.companyId;
    }
    this.getBankList();

    //     // 单位与证件绑定与否
    //     const binding = this.judgeBinding(
    //       info.obj.appliType,
    //       info.obj.identifyType
    //     );
    //     if (!binding) {
    //       this.form.identifyType = "";
    //       this.form.identifyNumber = "";
    //     }
    //   }
    //   // 单位名称始终拿当前农场名，收款人姓名始终拿当前企业名
    this.form.appliName = this.farmInfo ? this.farmInfo.farmName : "";
    // this.form.accountName = this.companyInfo
    //   ? this.companyInfo.companyName
    //   : "";
    //   this.judgeFormItem();
    // }
    if (this.farmInfo && this.farmInfo.countyId === "310115") {
      this.isPuDong = true;
    }
  },
  methods: {
    //数据回显
    getdetailInfo(info) {
      this.title = "投保人信息编辑";
      this.form = Object.assign(this.form, info);
      Object.keys(this.form).forEach((key) => {
        if (key === "validDate") {
          this.form.validDate =
            info.validDate == "2099-01-01" ? "" : info.validDate;
          this.longEffective = info.validDate == "2099-01-01" ? true : false;
        } else {
          this.form[key] = info[key];
        }
      });
      this.formInfoId = info.id || null;
    },
    //提交
    submitHandle() {
      this.$refs["formDom"].validate(async (valid) => {
        if (valid) {
          const params = {
            bankBranchCode: this.form.bankBranchCode,
            bankBranchName: this.form.bankBranchName,
            bankCode: this.form.bankCode,
            bankName: this.form.bankName,
            comCode: this.form.comCode,
            companyId: this.companyId,
            farmId: this.farmId,
            // legalPerson: this.form.legalPerson,
            appliName: this.form.appliName,
            appliType: this.form.appliType,
            identifyType: this.form.identifyType,
            identifyNumber: this.form.identifyNumber,
            linkerName: this.form.linkerName,
            validDate:
              this.form.validDate == "" && this.longEffective
                ? "2099-01-01"
                : this.form.validDate,
            phoneNumber: this.form.phoneNumber,
            appliAddress: this.form.appliAddress,
            accountName: this.form.accountName,
            accountCode: this.form.accountCode,
            id: this.formInfoId,
          };
          try {
            if (this.formInfoId) {
              this.$confirm(
                "是否确定提交当前信息进行认证审核(注：提交后信息需重新认证，认证中信息无法投保)",
                "提示",
                {
                  showClose: true,
                  type: "warning",
                  customClass: "message-box-height",
                }
              )
                .then(async () => {
                  //编辑
                  const res = await editPersonInfo(params);
                  if (res.respCode === 0) {
                    this.$emit("changeStatus", false);
                    this.$message({
                      message: "编辑成功",
                      type: "success",
                    });
                    this.longEffective = false;
                    this.title = "新增投保人信息";
                    this.formInfoId = null;
                    this.$refs.formDom.resetFields();
                    this.branchBankList = [];
                  }
                })
                .catch(() => {});
            } else {
              this.$confirm("是否确定提交当前信息进行认证审核", "提示", {
                showClose: true,
                type: "warning",
                customClass: "message-box-height",
              })
                .then(async () => {
                  //新增
                  const res = await addPersonInfo(params);
                  if (res.respCode === 0) {
                    this.$emit("changeStatus", false);
                    this.$message({
                      message: "新增成功",
                      type: "success",
                    });
                    this.longEffective = false;
                    this.title = "新增投保人信息";
                    this.formInfoId = null;
                    this.$refs.formDom.resetFields();
                    this.branchBankList = [];
                  }
                })
                .catch(() => {});
            }
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
    //取消
    cancelHandle() {
      this.$emit("changeStatus", false);
      this.$refs.formDom.resetFields();
      this.branchBankList = [];
      this.longEffective = false;
      this.title = "新增投保人信息";
    },
    changeEfficient(val) {
      if (val) {
        this.form.validDate = "";
      }
    },
    judgeBinding(appliType, identifyType) {
      if (Number(appliType) === 1) {
        // 个人
        return ["01", "03"].includes(identifyType);
      }
      if (Number(appliType) === 2) {
        return identifyType === "70";
      }
    },
    handleSelectAppliType(val) {
      const binding = this.judgeBinding(val, this.form.identifyType);
      if (!binding) {
        this.form.identifyType = "";
        this.form.identifyNumber = "";
      }
    },
    // 提交每一项
    submitItemInfo(val, propName) {
      if (propName === "bankName") {
        // 当前选的是银行时
        this.form.bankBranchName = "";
        this.form.bankBranchCode = "";
        const bank = this.bankList.find((item) => item.bankTypeName == val);
        this.form.bankCode = bank ? bank.bankTypeCode : "";
        this.branchBankPageNo = 1;
        this.branchBankKeyword = "";
        this.getBranchBankList();
      }
      if (propName === "bankBranchName") {
        // 当前选择是支行时
        const branchBank = this.branchBankList.find(
          (item) => item.bankBranchTypeName == val
        );
        this.form.bankBranchCode = branchBank
          ? branchBank.bankBranchTypeCode
          : "";
      }
      // 取消失焦提交
      // this.$refs.formDom.validateField(propName, (errorMsg) => {
      //   console.log(`${propName}校验结果：`, errorMsg);
      //   if (!errorMsg) {
      //     const info = { ...this.form, id: this.formInfoId };
      //     addInsureInfo(info).then((res) => {
      //       console.log(`提交表单信息结果：`, res);
      //     });
      //   }
      // });
    },
    // 处理表单默认值
    // processFormDef() {
    //   if (!this.companyInfo || !this.farmInfo) {
    //     this.companyInfo = getStorage("COMPANYINFO");
    //     this.farmInfo = getStorage("FARMINFO");
    //   }
    //   if (this.companyInfo) {
    //     // 证件号码
    //     this.form.identifyNumber = this.companyInfo.enterpriseCreditCode;

    //     // 单位名称
    //     // this.form.appliName = companyInfo.companyName;
    //     // 收款人姓名
    //     // this.form.accountName = companyInfo.companyName;
    //   }
    //   if (this.farmInfo && this.farmInfo.farmAddress) {
    //     const { provinceName, cityName, countyName, farmAddress } =
    //       this.farmInfo;
    //     // 经营地址
    //     this.form.appliAddress =
    //       provinceName + cityName + countyName + farmAddress;
    //   }
    //   // 联系人电话
    //   this.form.phoneNumber = getStorage("PHONE") || "";
    // },
    // 搜索银行
    searchBank(keyword) {
      this.bankPageNo = 1;
      this.bankKeyword = keyword;
      this.getBankList();
    },
    // 搜索银行失焦时
    onBlurWithBankName() {
      setTimeout(() => {
        this.bankList = this.temp_bankList;
      }, 500);
    },
    // 加载更多银行数据
    loadMoreBank() {
      if (this.bankList.length < this.bankTotal) {
        this.bankPageNo = this.bankPageNo + 1;
        this.getBankList();
      }
    },
    // 获取银行列表
    async getBankList() {
      const ajaxJson = {
        keyword: this.bankKeyword,
        pageNo: this.bankPageNo,
        pageSize: 10,
      };
      const res = await getBankList(ajaxJson);
      console.log("银行列表：", res);
      if (res.respCode == 0) {
        if (this.bankPageNo == 1) {
          this.bankList = res.obj.list;
          if (!this.bankKeyword) {
            this.temp_bankList = this.bankList;
          }
        } else if (this.bankPageNo > 1) {
          this.bankList = this.bankList.concat(res.obj.list);
        }
        this.bankTotal = res.obj.totalCount;
      }
    },

    // 搜索支行
    searchBranchBank(keyword) {
      this.branchBankPageNo = 1;
      this.branchBankKeyword = keyword;
      this.getBranchBankList();
    },
    // 搜索支行失焦
    onBlurWithBankBranchName() {
      setTimeout(() => {
        this.branchBankList = this.temp_branchBankList;
      }, 500);
    },
    // 加载更多支行数据
    loadMoreBranchBank() {
      if (this.branchBankList.length < this.branchBankTotal) {
        this.branchBankPageNo = this.branchBankPageNo + 1;
        this.getBranchBankList();
      }
    },
    // 获取支行列表
    async getBranchBankList() {
      const ajaxJson = {
        bankTypeCode: this.form.bankCode,
        keyword: this.branchBankKeyword,
        pageNo: this.branchBankPageNo,
        pageSize: 10,
      };

      const res = await getBranchBankList(ajaxJson);
      console.log("支行列表：", res);
      if (res.respCode == 0) {
        if (this.branchBankPageNo == 1) {
          this.branchBankList = res.obj.list;
          if (!this.branchBankKeyword) {
            this.temp_branchBankList = res.obj.list;
          }
        } else if (this.branchBankPageNo > 1) {
          this.branchBankList = this.branchBankList.concat(res.obj.list);
        }
        this.branchBankTotal = res.obj.totalCount;
      }
    },
    // 判断表单是否全都有初始信息
    judgeFormItem() {
      const formVals = Object.values(this.form);
      const someNoVal = formVals.some((val) => val == null || val === "");
      if (someNoVal) {
        this.$emit("openForm");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  width: 240px;
}
::v-deep .insure-info-dialog .el-dialog__header {
  background-color: #64c3a4;

  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-form-item.accountNameItem .el-form-item__label {
  line-height: 20px;
}
</style>
